import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from '../../shared/shared.module';
import {RouterModule, Routes} from '@angular/router';

import {NewsletterPageComponent} from './newsletter-page.component';


const routes: Routes = [{ path: '', component: NewsletterPageComponent }];

@NgModule({
  declarations: [NewsletterPageComponent],
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        SharedModule
    ],
    exports: [RouterModule]
})
export class NewsletterPageModule { }
